import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EdlCommonComponentsModule, EdlCommonDirectiveModule, EdlCommonPipesModule, EdlDatePickerModule, EdlEntriesModule } from '@edl-development/edl-common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UIRouterModule } from '@uirouter/angular';
import { LaddaModule } from 'angular2-ladda';
import { ComplyDirectivesModule } from 'src/app/directives/comply-directives.module';
import { GroupsCommonModule } from 'src/app/groups/common/groups-common.module';
import { ItemPacketsCommonModule } from 'src/app/item-packets/common/item-packets-common.module';
import { ComponentModule } from '../../../components/components.module';
import { PipesModule } from '../../../pipes/pipes.module';
import { InCompliancePrintReportComponent } from './in-compliance-print-report/in-compliance-print-report.component';
import { VolunteerPrintReportStates } from './volunteer-print-reports.states';

@NgModule({
    imports: [
        CommonModule,
        ComponentModule,
        ComplyDirectivesModule,
        EdlCommonComponentsModule,
        EdlCommonDirectiveModule,
        EdlCommonPipesModule,
        EdlEntriesModule,
        EdlDatePickerModule,
        GroupsCommonModule,
        ItemPacketsCommonModule,
        FormsModule,
        LaddaModule,
        NgbModule,
        PipesModule,
        ReactiveFormsModule,
        UIRouterModule.forChild({
            states: VolunteerPrintReportStates
        })
    ],
    declarations: [
        InCompliancePrintReportComponent
    ]
})
export class VolunteerPrintReportsModule { }